import { getTranslations } from "../../translations";
import { Popup, PopupButton, PopupContent, PopupPosition } from "../../utilities/popup";
import { sendDataLayer } from "../ecommerce/ecommerce";

declare const Cookies: any;

declare function setupButton(element: HTMLElement): void;

const deviceType = String((window as any).deviceType ?? "").toLowerCase();

const isMobileDevice =
    deviceType === "phone" ||
    deviceType === "tablet" ||
    deviceType === "mobile" ||
    window.matchMedia("(max-width: 768px)").matches;

document.addEventListener('DOMContentLoaded', () =>
{
    reInitAr();
});

(window as any).showARModalPopup = false;
(window as any).openCamera = true;

export class arPopup
{
    root;
    target;
    popup: Popup;
    element;
    arButton: HTMLElement;

    constructor(element: HTMLElement)
    {
        this.target = $(element).data("popup-target");
        this.element = element;
        this.arButton = document.createElement("ar-button");
        $(this.arButton).attr("src", $(this.element).find("#ar-button").attr("data-src"));
        $(this.arButton).attr("ios-src", $(this.element).find("#ar-button").attr("data-ios-src"));
        $(this.arButton).attr("title", $(this.element).find("#ar-button").attr("data-title"));
        setTimeout(() => {
            setupButton(this.arButton);
        }, 1000);

        this.initAr();
        this.initArPopup();
        this.attachEvents(element);
    }

    private attachEvents(element: HTMLElement): void
    {
        $(element).on("click", (e) =>
        {
            if (!isMobileDevice)
            {
                e.preventDefault();
                return false;
            }

            e.stopPropagation();
            e.preventDefault();

            this.openAr();
        });
    }

    public openAr = () =>
    {
        if (Cookies.get("DisableARModalPopup") === "1") {
            this.arButton.click();
        }
        else {
            if (!this.popup)
                this.initArPopup();

            this.popup.goToTab(0);
            this.popup.show();

            window.setTimeout(() =>
            {
                this.updateArPopupButtons();
            }, 0);
        }

        return false;
    };

    private updateArPopupButtons = (): void =>
    {
        const popup = document.querySelector<HTMLElement>("#ar-popup.g-popup--visible");

        if (!popup)
        {
            return;
        }

        const buttons = popup.querySelector<HTMLElement>(".g-popup__footer-buttons");
        const nextButton = popup.querySelector<HTMLElement>(".js-ar-next");
        const skipButton = popup.querySelector<HTMLElement>(".js-ar-skip");
        const continueButton = popup.querySelector<HTMLElement>(".js-ar-continue");

        if (!buttons || !nextButton)
        {
            return;
        }

        buttons.style.flexDirection = "column";

        if (nextButton.classList.contains("is-hidden"))
        {
            skipButton?.classList.add("is-hidden");
            continueButton?.classList.remove("is-hidden");

            return;
        }

        skipButton?.classList.remove("is-hidden");
        continueButton?.classList.add("is-hidden");
    };

    private initAr = () =>
    {
        if (isMobileDevice)
        {
            const existingScript = document.querySelector<HTMLScriptElement>(
                'script[data-ar-model-viewer="true"]'
            );

            if (existingScript)
            {
                $(".proddetail-augmented-reality").show();
                return;
            }

            const script = document.createElement("script");
            script.src = `${shopConfig().staticDomain}/js/library/ar-button-model-viewer.min.js?v=${shopConfig().versionNumber}`;
            script.dataset.arModelViewer = "true";
            script.onload = () =>
            {
                $(".proddetail-augmented-reality").show();
            };

            script.onerror = () =>
            {
                console.error("AR-script kon niet worden geladen:", script.src);
                $(".proddetail-augmented-reality").hide();
            };

            document.body.appendChild(script);
        }
        else
        {
            $(".proddetail-augmented-reality").hide();
            $(this.target).hide();
        }
    };

    public initArPopup = () => {
        const instance = this;
        const contentHolders: Array<PopupContent> = [];
        let count = 0;

        $(this.target).find("li").each(function () {
            count++;

            const contentItem = new PopupContent();
            let text = "";

            switch (count) {
                case 1: {
                    text = getTranslations().ARStep1Instructions;
                    break;
                }
                case 2: {
                    text = getTranslations().ARStep2Instructions;
                    break;
                }
                case 3: {
                    text = getTranslations().ARStep3Instructions;
                    break;
                }
                case 4: {
                    text = getTranslations().ARStep4Instructions;

                    const content = $(this).find(".ar-step-content");

                    $(content).find("#arstep4note").text(getTranslations().ARStep4Note);

                    $(content).find("#armodalbuttoncontinue")
                        .text(getTranslations().ARStep4Continue)
                        .hide();

                    $(content).find("#arstep4checkboxtext").text(getTranslations().ARStep4CheckboxText);

                    break;
                }
            }

            let content = $(this).find(".ar-step-content");
            $(content).find(".ar-step-instructions").text(text);

            contentItem.content = content[0];
            contentItem.index = count;
            contentHolders.push(contentItem);
        });

        const buttons: Array<PopupButton> = [];

        const nextButton = new PopupButton();
        nextButton.isNextButton = true;
        nextButton.label = getTranslations().txtNext;
        nextButton.className = "btn btn-green btn-lg js-ar-next";
        nextButton.onClick = (e) => {
            sendDataLayer({
                'event': 'AR',
                'category': 'Navigatie',
                'action': 'AR',
                'label': 'Opslaan',
                'arStep': 'Stap ' + instance.popup.activeTab
            });

            this.popup.nextTab();

            window.setTimeout(() => {
                this.updateArPopupButtons();
            }, 0);
        };

        buttons.push(nextButton);

        const skipButton = new PopupButton();
        skipButton.label = getTranslations().txtSkip;
        skipButton.className = "btn btn-white btn-lg js-ar-skip";
        skipButton.onClick = () => {
            this.arButton.click();
        }
        skipButton.closeOnCLick = true;

        buttons.push(skipButton);

        const continueButton = new PopupButton();
        continueButton.label = getTranslations().ARStep4Continue;
        continueButton.className = "btn btn-green btn-lg js-ar-continue is-hidden";
        continueButton.onClick = () => {
            this.arButton.click();
        };

        buttons.push(continueButton);

        this.popup = new Popup({
            id: "ar-popup",
            content: contentHolders,
            buttons: buttons,
            mobilePosition: PopupPosition.Drawer,
            closeButton: true,
            onHide: () => {
                if ($("#arStep4Checkbox:checked").length > 0) {
                    Cookies.set('DisableARModalPopup', "1", {
                        expires: 365,
                        path: '/'
                    });
                }
            }
        });
    }
};

export const popups = [];

export const reInitAr = () =>
{
    document.querySelectorAll(".js-ar-popup").forEach((item: HTMLElement) => {
        popups.push(new arPopup(item));
    });
};

(window as any).popups = popups;
(window as any).reInitAr = reInitAr;